"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
// Import specialized audio services
const audio_1 = require("./audio");
const AudioWebsocketService_1 = __importStar(require("./audio/AudioWebsocketService"));
/**
 * Main AudioService that acts as an entry point to all audio functionality
 * This service delegates calls to specialized sub-services
 */
let AudioService = class AudioService extends client_1.RWSService {
    constructor(apiService, recordingService, playbackService, speechToTextService, textToSpeechService, sessionService, voiceService, audioWebsocketService) {
        super();
        this.apiService = apiService;
        this.recordingService = recordingService;
        this.playbackService = playbackService;
        this.speechToTextService = speechToTextService;
        this.textToSpeechService = textToSpeechService;
        this.sessionService = sessionService;
        this.voiceService = voiceService;
        this.audioWebsocketService = audioWebsocketService;
    }
    // === Voice Management (delegated to AudioVoiceService) ===
    /**
     * Get available voices from ElevenLabs
     */
    async getVoices() {
        return this.voiceService.getVoices();
    }
    /**
     * Get voice by ID
     */
    async getVoiceById(voiceId) {
        return this.voiceService.getVoiceById(voiceId);
    }
    /**
     * Get recommended voices
     */
    async getRecommendedVoices() {
        return this.voiceService.getRecommendedVoices();
    }
    /**
     * Get user info (usage stats, etc.)
     */
    async getUserInfo() {
        return this.voiceService.getUserInfo();
    }
    // === Audio Recording (delegated to AudioRecordingService) ===
    /**
     * Check if audio recording is supported
     */
    isRecordingSupported() {
        return this.recordingService.isRecordingSupported();
    }
    /**
     * Request microphone permission
     */
    async requestMicrophonePermission() {
        return this.recordingService.requestMicrophonePermission();
    }
    /**
     * Start audio recording
     */
    async startRecording(options = {}) {
        return this.recordingService.startRecording(options);
    }
    /**
     * Stop audio recording
     */
    async stopRecording() {
        return this.recordingService.stopRecording();
    }
    /**
     * Check if currently recording
     */
    isCurrentlyRecording() {
        return this.recordingService.isCurrentlyRecording();
    }
    // === Speech-to-Text (delegated to SpeechToTextService) ===
    /**
     * Transcribe audio blob to text
     */
    async transcribeAudio(audioBlob, language = 'en', sessionId) {
        return this.speechToTextService.transcribeAudio(audioBlob, language, sessionId);
    }
    /**
     * Transcribe audio file to text
     */
    async transcribeFile(file, language = 'en', sessionId) {
        return this.speechToTextService.transcribeFile(file, language, sessionId);
    }
    /**
     * Record and transcribe audio in one step
     */
    async recordAndTranscribe(language = 'en', sessionId, maxDuration = 30) {
        return new Promise(async (resolve) => {
            const recordingOptions = {
                language,
                sessionId,
                autoStop: maxDuration,
                onRecordingStop: async () => {
                    const audioBlob = await this.stopRecording();
                    if (audioBlob) {
                        const result = await this.transcribeAudio(audioBlob, language, sessionId);
                        resolve(result);
                    }
                    else {
                        resolve({
                            success: false,
                            error: 'No audio data recorded'
                        });
                    }
                },
                onError: (error) => {
                    resolve({
                        success: false,
                        error: error.message
                    });
                }
            };
            const started = await this.startRecording(recordingOptions);
            if (!started) {
                resolve({
                    success: false,
                    error: 'Failed to start recording'
                });
            }
        });
    }
    // === Text-to-Speech (delegated to TextToSpeechService) ===
    /**
     * Convert text to speech and get audio URL
     */
    async textToSpeech(request) {
        return this.textToSpeechService.textToSpeech(request);
    }
    /**
     * Convert text to speech and return audio blob
     */
    async textToSpeechBlob(request) {
        return this.textToSpeechService.textToSpeechBlob(request);
    }
    /**
     * Stream text to speech
     */
    async streamTextToSpeech(request, options = {}) {
        return this.textToSpeechService.streamTextToSpeech(request, options);
    }
    // === Audio Playback (delegated to AudioPlaybackService) ===
    /**
     * Play audio from URL or Blob
     */
    async playAudio(audioSource, options = {}) {
        return this.playbackService.playAudio(audioSource, options);
    }
    /**
     * Stop current audio playback
     */
    stopAudio() {
        this.playbackService.stopAudio();
    }
    /**
     * Pause current audio
     */
    pauseAudio() {
        this.playbackService.pauseAudio();
    }
    /**
     * Resume current audio
     */
    async resumeAudio() {
        return this.playbackService.resumeAudio();
    }
    /**
     * Get current playback state
     */
    getPlaybackState() {
        return this.playbackService.getPlaybackState();
    }
    /**
     * Set playback volume (0-100)
     */
    setVolume(volume) {
        this.playbackService.setVolume(volume);
    }
    /**
     * Seek to specific time
     */
    seekTo(time) {
        this.playbackService.seekTo(time);
    }
    // === Session Management (delegated to AudioSessionService) ===
    /**
     * Create audio session
     */
    async createAudioSession(request) {
        return this.sessionService.createAudioSession(request);
    }
    /**
     * Get audio session
     */
    async getAudioSession(sessionId) {
        return this.sessionService.getAudioSession(sessionId);
    }
    /**
     * End audio session
     */
    async endAudioSession(sessionId) {
        return this.sessionService.endAudioSession(sessionId);
    }
    // === Continuous Conversation (delegated to AudioSessionService) ===
    /**
     * Start audio conversation
     */
    async startAudioConversation(conversationId, voiceId, language) {
        return this.sessionService.startAudioConversation(conversationId, voiceId, language);
    }
    /**
     * Process audio conversation (send audio, get audio response)
     */
    async processAudioConversation(audioBlob, sessionId, language, streamResponse = false) {
        return this.sessionService.processAudioConversation(audioBlob, sessionId, language, streamResponse);
    }
    /**
     * Text to audio conversation
     */
    async textToAudioConversation(request) {
        return this.sessionService.textToAudioConversation(request);
    }
    /**
     * Change session voice
     */
    async changeSessionVoice(sessionId, voiceId) {
        return this.sessionService.changeSessionVoice(sessionId, voiceId);
    }
    // === Utility Methods ===
    /**
     * Get session stats (admin only)
     */
    async getSessionStats() {
        return this.sessionService.getSessionStats();
    }
    /**
     * Validate audio file for transcription
     */
    validateAudioFile(file) {
        return this.speechToTextService.validateAudioFile(file);
    }
    /**
     * Validate text for TTS
     */
    validateText(text) {
        return this.textToSpeechService.validateText(text);
    }
    /**
     * Optimize text for speech synthesis
     */
    optimizeTextForSpeech(text) {
        return this.textToSpeechService.optimizeTextForSpeech(text);
    }
    /**
     * Get supported languages for transcription
     */
    getSupportedLanguages() {
        return this.speechToTextService.getSupportedLanguages();
    }
    /**
     * Get default voice for different use cases
     */
    getDefaultVoice(category = 'conversation') {
        return this.voiceService.getDefaultVoice(category);
    }
    /**
     * Clean up all resources
     */
    destroy() {
        this.playbackService.destroy();
    }
};
exports.AudioServiceInstance = AudioService;
exports.AudioServiceInstance = AudioService = __decorate([
    __param(0, client_1.ApiService),
    __param(1, audio_1.AudioRecordingService),
    __param(2, audio_1.AudioPlaybackService),
    __param(3, audio_1.SpeechToTextService),
    __param(4, audio_1.TextToSpeechService),
    __param(5, audio_1.AudioSessionService),
    __param(6, audio_1.AudioVoiceService),
    __param(7, AudioWebsocketService_1.default),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object, typeof (_b = typeof audio_1.AudioRecordingServiceInstance !== "undefined" && audio_1.AudioRecordingServiceInstance) === "function" ? _b : Object, typeof (_c = typeof audio_1.AudioPlaybackServiceInstance !== "undefined" && audio_1.AudioPlaybackServiceInstance) === "function" ? _c : Object, typeof (_d = typeof audio_1.SpeechToTextServiceInstance !== "undefined" && audio_1.SpeechToTextServiceInstance) === "function" ? _d : Object, typeof (_e = typeof audio_1.TextToSpeechServiceInstance !== "undefined" && audio_1.TextToSpeechServiceInstance) === "function" ? _e : Object, typeof (_f = typeof audio_1.AudioSessionServiceInstance !== "undefined" && audio_1.AudioSessionServiceInstance) === "function" ? _f : Object, typeof (_g = typeof audio_1.AudioVoiceServiceInstance !== "undefined" && audio_1.AudioVoiceServiceInstance) === "function" ? _g : Object, typeof (_h = typeof AudioWebsocketService_1.AudioWebsocketServiceInstance !== "undefined" && AudioWebsocketService_1.AudioWebsocketServiceInstance) === "function" ? _h : Object])
], AudioService);
exports.default = AudioService.getSingleton();
